import { render, staticRenderFns } from "./VersionNumber.vue?vue&type=template&id=bd93a412"
import script from "./VersionNumber.vue?vue&type=script&lang=js"
export * from "./VersionNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports